import {request} from '../helpers/request'
import React from 'react';
import {t} from '../helpers/translate'
let config = require('config');
import LoadingComponent from './common/LoadingComponent'

class ReferenceId extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      policyNumber: '',
      referenceId: '',
      url: `${config.default.api}/getreferenceid/`,
      processing: false,
      loadingText: 'Processing Request',
    }
  }

  saveResponseData(data, statusCode) {
    if (statusCode === 200) {
      this.setState({referenceId: data.reference_id, processing: false})
    } else {
      this.setState({referenceId: data.messages[0], processing: false})
    }
  }

  sendData() {
    this.setState({processing: true})
    request(this.state.url + this.state.policyNumber, 'GET', null, this.saveResponseData.bind(this));
  }

  updatePolicyNumber(event){
    this.setState({policyNumber: event.target.value})
  }

  checkPolicyNumberLength(){
    return this.state.policyNumber.length < 10
  }

  render() {
    return (<div className="container">
      <div className="text-center bg-inherit">
        <h2>{t('Reference ID Lookup')}</h2>
      </div>
      <div className="row">
        <input type='text' onChange={this.updatePolicyNumber.bind(this)}></input>
        <button className="btn btn-lg button-primary" className={this.checkPolicyNumberLength() ? 'disabled-button' : ''} bsStyle="primary" onClick={this.sendData.bind(this)}>
          {t('Get Reference ID')}
        </button>
      </div>
      <br />
      <div className="row">
        Reference ID: {this.state.referenceId}
      </div>

      <LoadingComponent show={this.state.processing} text={this.state.loadingText}/>

    </div>);
  }
}

ReferenceId.defaultProps = {};

export default ReferenceId;



// WEBPACK FOOTER //
// ./src/components/ReferenceId.js